

export class CompanyDto implements ICompanyDto {
    id!: number;
    companyName!: string | undefined;
    companyWebsite!: string | undefined;
    personName!: string | undefined;
    companyLegalName!: string | undefined;
    panCard!: string | undefined;
    tanCard!: string | undefined;
    address!: string | undefined;
    contactNo!: string | undefined;
    email!: string | undefined;
    isActive!: boolean;
    pfNo!: string | undefined;
    pfGroup!: string | undefined;
    pfEstNo!: string | undefined;
    esicNo!: string | undefined;
    lwfNo!: string | undefined;
    ptNo!: string | undefined;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyName = _data["companyName"];
            this.companyWebsite = _data["companyWebsite"];
            this.personName = _data["personName"];
            this.companyLegalName = _data["companyLegalName"];
            this.panCard = _data["panCard"];
            this.tanCard = _data["tanCard"];
            this.address = _data["address"];
            this.contactNo = _data["contactNo"];
            this.email = _data["email"];
            this.isActive = _data["isActive"];
            this.pfNo = _data["pfNo"];
            this.pfGroup = _data["pfGroup"];
            this.pfEstNo = _data["pfEstNo"];
            this.esicNo = _data["esicNo"];
            this.lwfNo = _data["lwfNo"];
            this.ptNo = _data["ptNo"];
        }
    }

    static fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyName"] = this.companyName;
        data["companyWebsite"] = this.companyWebsite;
        data["personName"] = this.personName;
        data["companyLegalName"] = this.companyLegalName;
        data["panCard"] = this.panCard;
        data["tanCard"] = this.tanCard;
        data["address"] = this.address;
        data["contactNo"] = this.contactNo;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        data["pfNo"] = this.pfNo;
        data["pfGroup"] = this.pfGroup;
        data["pfEstNo"] = this.pfEstNo;
        data["esicNo"] = this.esicNo;
        data["lwfNo"] = this.lwfNo;
        data["ptNo"] = this.ptNo;
        return data; 
    }
}

export interface ICompanyDto {
    id: number;
    companyName: string | undefined;
    companyWebsite: string | undefined;
    personName: string | undefined;
    companyLegalName: string | undefined;
    panCard: string | undefined;
    tanCard: string | undefined;
    address: string | undefined;
    contactNo: string | undefined;
    email: string | undefined;
    isActive: boolean;
    pfNo: string | undefined;
    pfGroup: string | undefined;
    pfEstNo: string | undefined;
    esicNo: string | undefined;
    lwfNo: string | undefined;
    ptNo: string | undefined;
}

